// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x9yO","newExpiryDate":"styles_newExpiryDate__2_cPU","footer":"styles_footer__2q2vn"};